import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import './menu.scss'
import { Alert } from '../../components'
import { t } from 'i18next'
import { closeIcon } from '../../assets'

export const MenuChild = ({
    children,
    setActive,
    idx,
    active,
    icon,
    isDesktop,
    href,
    onClickCallback,
    path,
    disableActive = false,
    menuOption,
    setDisplayOpt,
    displayOpt,
    isVisible: { isVisible, idx: id },
    ...props
}) => {
    const location = useLocation()
    const navigate = useNavigate()
    const activePath = location.pathname.split('/')[1]
    const menuKey = path ?? idx
    let prevKey = 'home'
    const [errorMsg, setErrorMsg] = useState(false)
    useEffect(() => {
        if (activePath === path) {
            setActiveMenu(menuKey)
        }
    }, [location])
    // handle set active menu (keyed by path so insert order does not shift highlight)
    const setActiveMenu = (key) => {
        setActive((prevState) => {
            prevKey = prevState.key
            return {
                status: true,
                key,
                prevKey: prevState.key
            }
        })
        // persist active menu
        sessionStorage.setItem(
            'activeMenu',
            JSON.stringify({ status: true, key, prevKey })
        )
    }

    const handleSetActiveLink = (key) => {
        !disableMenuChild && setActiveMenu(key)
    }
    // retrieve active menu
    const activeStore = JSON.parse(sessionStorage.getItem('activeMenu')) || {
        status: true,
        key: 'home'
    }
    const activeStyle =
        activeStore.key === menuKey && !disableActive
            ? 'menu-child--active'
            : ''
    const disableMenuChild = !isVisible && id === idx
    const desktopChild = isDesktop ? 'desktop-menu-child' : ''

    const pageNavigationHandler = () => {
        if (disableMenuChild) {
            setErrorMsg(true)
            return setTimeout(() => setErrorMsg(false), 2500)
        }
        if (onClickCallback) {
            onClickCallback()
        } else {
            navigate(href || '#')
        }
        // handle and restore prev active Menu
        const handlePrevMenu = () => {
            setActiveMenu(active.prevKey)
            return ''
        }
        if (menuOption) {
            setDisplayOpt((prevState) => ({
                key: prevState?.key === idx ? handlePrevMenu() : idx
            }))
            return
        }
        setDisplayOpt({ key: '' })
    }

    const menuClickHandler = () => {
        pageNavigationHandler()
        handleSetActiveLink(menuKey)
    }

    return (
        <button
            onClick={menuClickHandler}
            className="menu-child--link"
            aria-label="menu-child"
        >
            <div
                className={[
                    desktopChild,
                    'menu-child',
                    `${!disableMenuChild && activeStyle}`,
                    `${disableMenuChild && 'menu-child--disable'}`
                ]
                    .join(' ')
                    .trim()}
                aria-label="menu-child-link"
                {...props}
            >
                <span className="menu-icon">{icon}</span>
                <p className="menu-content">{children}</p>
            </div>
            {displayOpt.key === idx && (
                <div className="menu-option-parent">{menuOption}</div>
            )}
            {errorMsg && (
                <div data-testid="error-msg">
                    <Alert
                        type="floating"
                        status="error"
                        icon={true}
                        iconType={closeIcon({
                            color: 'red'
                        })}
                    >
                        {t('permission.noPermission')}
                    </Alert>
                </div>
            )}
        </button>
    )
}

MenuChild.propTypes = {
    onClick: PropTypes.func,
    children: PropTypes.any,
    setActive: PropTypes.func,
    idx: PropTypes.number,
    active: PropTypes.object,
    icon: PropTypes.element,
    isDesktop: PropTypes.bool,
    href: PropTypes.string,
    onClickCallback: PropTypes.func,
    path: PropTypes.string,
    disableActive: PropTypes.bool,
    menuOption: PropTypes.any,
    setDisplayOpt: PropTypes.func,
    displayOpt: PropTypes.object,
    isVisible: PropTypes.object
}
